module.exports = __webpack_public_path__ + "img/gy.171f4427.svg";